
export default {
  props: {
    title: String,
    place: String,
    description: String,
    thumbnail: String,
    tags: Array,
    slug: String,
    publishOn: String,
  },
  computed: {
    isArabic() {
      return this.$i18n.locale === "ar";
    },
  },
  methods: {
    getTagClass(index) {
      const classNames = ["tag-color-1", "tag-color-2", "tag-color-3"];
      return classNames[index % classNames.length];
    },
  },
};
